module.exports = __webpack_public_path__ + "img/fs-shenhezhong.b9f915c6.png";